module.exports = __webpack_public_path__ + "static/shipping-list-c5aa527b12da321c198388c639f8c53a.png";